<template>
    <div class="content-holder">
        <div class="flex justify-between py-2 mb-6 border-b border-gray-200 sm:flex-nowrap h-11">
            <h3 class="font-medium leading-6 text-gray-900 text-md">
                Updates
            </h3>
            <button class="tw-button-blue medium" @click="openCreateModal(projectId)">Add Update</button>
        </div>

        <div class="centered loader is-large" v-if="loading"></div>
        <template v-else-if="isNotEmpty">
            <div class="bg-white shadow sm:rounded-lg sm:overflow-hidden">
                <div class="px-4 sm:px-6">
                    <ul class="divide-y divide-gray-100">
                        <li
                            v-for="update in projectUpdates"
                            :key="update.id"
                            class="py-6"
                            :id="'update-' + update.id"
                        >
                            <div class="flex items-start space-x-3">
                                <div class="w-full">
                                    <div class="flex justify-between">
                                        <div class="mb-1 text-gray-900 text-md"> {{ update.title }}</div>
                                        <div>
                                            <button @click="openEditModal(update)">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 text-gray-500">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                                </svg>
                                            </button>
                                            <button @click="openDeleteModal(update)">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-red-500 hover:text-red-700" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                                    stroke-width="2">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                    <div
                                        v-html="update.description"
                                        class="mb-2 text-sm text-gray-700"
                                    ></div>
                                    <div class="flex justify-between space-x-2 text-xs font-medium">

                                        <span class="text-gray-500">{{ update.user.name }}: {{ moment(update.created_at).format('LLLL') }}</span>
                                        <span
                                        v-if="update.project_id"
                                        class="text-gray-600"
                                        >
                                        Project: <a :href="route('projects.show', {project: update.project_id})" class="tw-link">{{ update.related.name }}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <div
          v-else
          class="p-3 rounded bg-blue-50"
        >
          <div class="flex-1 ml-3 md:flex md:justify-between">
            <p class="text-sm text-gray-800">{{ trans('app.project.update.none') }}</p>
          </div>
        </div>

        <tw-modal ref="deleteModal">
            <template v-slot:content>
                <div class="w-full px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                    <div class="w-full sm:flex sm:items-start">
                        <div class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto bg-red-100 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                            <!-- Heroicon name: outline/exclamation -->
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>
                        <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                                Are you Sure you want to delete this update?
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end px-4 py-3 space-x-2 sm:space-x-4 bg-gray-50 sm:px-6">
                    <button class="tw-button-gray" @click="onDeleteModalHidden">
                        Cancel
                    </button>
                    <button class="tw-button-red" @click="deleteUpdate">
                        Confirm
                    </button>
                </div>
            </template>
        </tw-modal>
        <project-update-add-edit-project-modal
            :project-id="projectId"
        ></project-update-add-edit-project-modal>
    </div>
</template>

<script>
export default {
    props: {
        projectId: {
            type: Number,
            required: true,
        },

        canUpdateAndDelete: {
            type: Boolean,
            default: false,
        },
    },

    data () {
        return {
            loading: true,
            projectUpdates: [],
            updateForDelete: null,
        };
    },

    computed: {
        isNotEmpty () {
            return ! _.isEmpty(this.projectUpdates);
        },

        deleteActionUrl () {
            if (_.isNull(this.updateForDelete)) {
                return '';
            }

            return this.route('project_updates.delete', {
                id: this.updateForDelete.id,
            });
        },
    },

    listeners: {
        async 'project-updates-updated' () {
            await this.fetchList();
        },
    },

    methods: {
        onDeleteModalHidden () {
            this.updateForDelete = null;
            this.$refs.deleteModal.hide();
        },

        async onDeleteSuccess () {
            this.$refs.deleteModal.hide();
            await this.fetchList();
            OSPEvent.$emit('project-updates-deleted', {});
        },

        openCreateModal (id) {
            OSPEvent.$emit('open-project-update-project-add-modal', id)
        },

        openEditModal (update) {
            OSPEvent.$emit('open-project-update-project-edit-modal', update);
        },

        openDeleteModal (update) {
            this.updateForDelete = update;
            this.$refs.deleteModal.show();
        },

        openDetailsModal (update) {
            OSPEvent.$emit('open-project-update-details', update);
        },

        getUpdateTypeLabel (update) {
            if (update.related_type === 'project') {
                return 'Project';
            }
        },

        getUpdateParentName (update) {
            if (update.related_type === 'project') {
                return update.related.name;
            }
        },

        async fetchList () {
            try {
                this.loading = true;
                let { data } = await axios.get(
                    this.route('project_updates.index', { project_id: this.projectId })
                );

                this.projectUpdates = data.data;

                OSPEvent.$emit('project-updates-fetched', {});
            } catch (errors) {
                console.error(errors);
            } finally {
                this.loading = false;
            }
        },

        async deleteUpdate () {
            try {
                let {response} = await axios.delete(this.deleteActionUrl);
            } catch (errors) {
                console.error(errors);
            } finally {
                this.onDeleteSuccess();
            }

        }
    },

    async created () {
        await this.fetchList();
    },
};
</script>
